import request from '../../axios/axiosconfig'

/**
 * 查询岗位列表
 * @returns 
 */
export function postList() {
  return request({
    url: '/ps/position/postList',
    method: 'get'
  })
}

/**
 * 查询所有权限
 * @returns 
 */
 export function getFunction(params) {
    return request({
      url: '/ps/position/getFunction',
      method: 'get',
      params: params
    })
  }

  /**
 * 添加岗位
 * @returns 
 */
 export function addPost(data) {
    return request({
      url: '/ps/position/addPost',
      method: 'post',
      data: data
    })
  }

   /**
 * 添加职位
 * @returns 
 */
 export function addPosition(data) {
    return request({
      url: '/ps/position/addPosition',
      method: 'post',
      data: data
    })
  }
  
    /**
 * 添加职位
 * @returns 
 */
 export function getPosition(id) {
    return request({
      url: '/ps/position/getPosition/'+id,
      method: 'get'
    })
  }

  /**
   * 修改岗位或者职位信息
   * @param {} data 
   * @returns 
   */
  export function modify(data) {
    return request({
      url: '/ps/position/modifyPosition',
      method: 'post',
      data: data
    })
  }

  
  /**
   * 删除职位或岗位
   * @param {} data 
   * @returns 
   */
   export function delPosition(data) {
    return request({
      url: '/ps/position/delPosition',
      method: 'delete',
      data: data
    })
  }

   /**
   * 查询职位或岗位信息
   * @returns 
   */
    export function getPostOrPositionFunction(params) {
      return request({
        url: '/ps/position/getPostOrPositionFunction',
        method: 'get',
        params: params
      })
    }


// WEBPACK FOOTER //
// ./src/api/sys/position.js